export const AUTH_ERROR_MESSAGES = {
  NO_AUTH_TOKEN: 'No authentication token found',
};

// Production Web Client IDs (for backend token verification)
export const ADMIN_AUTH_GOOGLE_CLIENT_ID = '681238678775-jmin8lfeljv9d9p4fhbk44ln8hj72bv7.apps.googleusercontent.com'  // ADMIN_AUTH_GOOGLE_CLIENT_ID (production)
export const RESIO_WEB_AUTH_GOOGLE_CLIENT_ID = '681238678775-aulk0366al6p3b2amltil0alvg3otd4f.apps.googleusercontent.com';  // RESIO_WEB_AUTH_GOOGLE_CLIENT_ID (production)

// Staging/Development Web Client IDs (for backend token verification)
export const ADMIN_AUTH_GOOGLE_CLIENT_ID_STAGING = '921501306582-9n9ihc8mtdph75th9a9g9c1u0il1buj4.apps.googleusercontent.com'  // ADMIN_AUTH_GOOGLE_CLIENT_ID (staging)
export const RESIO_WEB_AUTH_GOOGLE_CLIENT_ID_STAGING = '921501306582-a1p76votpkrq9ivdbei4k0a9d0rg3g5l.apps.googleusercontent.com';  // RESIO_WEB_AUTH_GOOGLE_CLIENT_ID (staging)

// iOS Client IDs - Staging (for native iOS Google Sign-In)
export const RESIO_IOS_AUTH_GOOGLE_CLIENT_ID_STAGING = '921501306582-ieargcl0149ocu92h1r4j5a5sdclmea2.apps.googleusercontent.com';  // iOS Client ID - Resident (staging)
export const ADMIN_IOS_AUTH_GOOGLE_CLIENT_ID_STAGING = '921501306582-9rf92lp1ndr02cvgj1mdoqvq8osk7vlg.apps.googleusercontent.com';  // iOS Client ID - Admin (staging)

// iOS Client IDs - Production (for native iOS Google Sign-In)
export const RESIO_IOS_AUTH_GOOGLE_CLIENT_ID = '681238678775-2mkqg51fgv7pp4emq2o93k6ujjcot5fg.apps.googleusercontent.com';  // iOS Client ID - Resident (production)
export const ADMIN_IOS_AUTH_GOOGLE_CLIENT_ID = '681238678775-4go8imu57mvomrg7s5bcbv4vdoasn98s.apps.googleusercontent.com';  // iOS Client ID - Admin (production)

// ============================================================
// Apple Sign-In Configuration
// ============================================================

// Apple Bundle ID for iOS native Sign in with Apple
// This is your app's bundle identifier - must match Xcode project settings
export const APPLE_IOS_BUNDLE_ID = 'com.resio.app';  // Production iOS Bundle ID
export const APPLE_IOS_BUNDLE_ID_STAGING = 'com.resio.staging.app';  // Staging iOS Bundle ID

// Apple Service IDs for Web Sign in with Apple (created in Apple Developer Portal)
// These are different from the iOS Bundle ID - they are Service IDs configured for web authentication
export const APPLE_WEB_CLIENT_ID = 'com.resio.web';  // Production Web Service ID
export const APPLE_WEB_CLIENT_ID_STAGING = 'com.resio.web.staging';  // Staging Web Service ID

// Redirect URIs for Apple Sign-In Web (must be configured in Apple Developer Portal)
export const APPLE_WEB_REDIRECT_URI = 'https://beta.resio.com/auth/apple/callback';  // Production
export const APPLE_WEB_REDIRECT_URI_STAGING = 'https://alpha.resio.com/auth/apple/callback';  // Staging